import React from 'react';
import { Link } from '@mui/material';
import Layout from '../../components/Layout';

/* eslint-disable react/prefer-stateless-function */
function UnauthorizedPage() {
  return (
    <Layout title="Accès non autorisé">
      <div
        style={{
          margin: '0 24px',
          padding: '158px 12px 32px 12px',
          textAlign: 'center',
        }}
      >
        <h1>Accès interdit</h1>
        <p>Vous n'êtes pas autorisé à accéder à cette page.</p>
        <Link href="/dashboard">Retour au dashboard</Link>
      </div>
    </Layout>
  );
}

export default UnauthorizedPage;
